// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import {DateTimePicker} from "react-widgets";
import AbstractField from "./AbstractField";
import * as commons from '../utils/commons'
import i18n from '../i18n/i18n';
require("./reactWidgetsInit");

// TODO PropTypes
/**
 * Input pro datumy.
 * Nutné speciálně řešit onBlur, protože react widgets ho nepodporují.
 */
class DateField extends AbstractField {
    constructor(props) {
        super(props);

        this.state = {
            value: this.getValueFromProps(props.value)
        }
    }

    componentDidMount() {
        const picker = ReactDOM.findDOMNode(this.refs.picker);
        picker.children[0].className += " form-control";
        picker.children[1].className += " input-group-btn";
        picker.children[1].children[0].className += " btn btn-secondary";
        picker.children[1].children[0].removeAttribute("tabindex");
    }

    /**
     * Konverze hodnoty z props na editovanou hodnotu.
     * @param value props hodnota
     * @return {null} hodnota, kterou potřebuje field pro editaci
     */
    getValueFromProps = (value) => {
        return (value && value != "") ? commons.localUTCToDate(value) : null;
    };

    /**
     * Konverze editované hodnoty pro poslání ven.
     * @param value editovaná hodnota
     * @return {null} hodnota pro odeslání ven
     */
    getValueForReturn = (value) => {
        return (value && value != "") ? commons.dateToLocalUTC(value) : null;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: this.getValueFromProps(nextProps.value)
        })
    };


    handleChange = (value, text) => {
        const {onChange} = this.props;

        this.setState({
            value: value
        });

        // TODO [compel] - až na tento kód narazíš, přijď nám říct, jestli se to nedá dělat lépe, Stanek a Pikl
        const formValue = this.getValueForReturn(value);
        // console.log("###", value, text, formValue)
        const e = {
            target: {
                type: "text",
                value: formValue,
            },
            stopPropagation: () => {
            },
            preventDefault: () => {
            }
        };

        onChange(e);
    };

    handleBlur = () => {
        const {onBlur} = this.props;
        const {value} = this.state;
        onBlur && onBlur(this.getValueForReturn(value));
    };

    render() {
        const {addonsBefore, addonsAfter, value, className, onChange, onBlur, ...props} = this.props;

        const objValue = this.getValueFromProps(value);

        const cls = classNames(
            "input-group",
            className
        );

        const field = <DateTimePicker
            ref="picker"
            className={cls}
            time={false}
            calendar={true}
            value={objValue}
            format="D. M. Y"
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            messages={{calendarButton: i18n('dateTimePicker.calendarButton')}}
            {...props}
        />;

        return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    }
}

export default DateField;
